// extracted by mini-css-extract-plugin
export default {"main":"home_main__JAJ-F","firstB":"home_firstB__tH1GK","button_top":"home_button_top__o+KJ7"};